/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../DefaultComponent/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { OrganizationList } from "../../Redux/Actions/OrganizationAction";
import ReactCountryFlag from "react-country-flag";
import { Pagination, Stack, Tooltip, Button } from "@mui/material";
import { getCountryCodeByName } from "../../utils/Helper";
import { S3MediaURL } from "../../Config/Config";
import { formatDate, calculateTotalPages } from "../../utils/Helper";
import Spinner from "../DefaultComponent/Spinner";
import ToastDefault from "../DefaultComponent/Toast";
import SelectOption from "../DefaultComponent/FilterHelper/SelectOption";
import SearchInput from "../DefaultComponent/FilterHelper/SelectInput";
import { OrganizarionFilter } from "../../utils/Json";
import { useNavigate } from "react-router-dom";
import CreateOrganizationDialog from "./CreateOrganizationDialog";

const Organizations = () => {
  const dispatch = useDispatch<any>();
  const [count, setcount]: any = useState(0);
  const [orgListDetails, setorgDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  let GetOrganizationData = useSelector(
    (state: any) => state.OrganizationListData
  );
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(12);
  const [select, setSelect] = useState<string>("Search By");
  const [search, setSearch] = useState<string>("");
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const navigate = useNavigate();

  const fetchOrganization = (params: any) => {
    setLoading(true);
    dispatch(OrganizationList(params));
    setLoading(false);
  };

  const buildListParams = (pageNumber: number = page) =>
    `?page=${pageNumber}&page_size=${rowsPerPage}${
      select !== "Search By" && search.trim() !== ""
        ? `&${select}=${search}`
        : ""
    }`;

  useEffect(() => {
    fetchOrganization(buildListParams());
  }, [dispatch, page, rowsPerPage, search, select]);

  useEffect(() => {
    if (GetOrganizationData?.data?.row) {
      setorgDetails(() => GetOrganizationData?.data?.row);
      setcount(() => GetOrganizationData?.data?.total_count);
    }
  }, [GetOrganizationData]);

  return (
    <>
      {loading && <Spinner />}
      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="col-md-12">
          <Breadcrumb
            pageTitle="Organizations"
            breadcrumbs={[
              {
                label: "Organizations",
                path: "/organizations",
                isActive: true,
              },
            ]}
          />
        </div>

        <div className="row m-2 mt-4 mb-0">
          <div className="col-md-12 filter-bar">
            <div className="d-flex flex-wrap justify-content-end align-items-center">
              <Button
                variant="contained"
                className="me-3 mb-2"
                onClick={() => setOpenCreateDialog(true)}
              >
                Create Organization
              </Button>
              <div className="col-md-6 search-bar">
                <SelectOption
                  option={OrganizarionFilter}
                  select={select}
                  setPage={setPage}
                  setSelect={setSelect}
                />
                <SearchInput
                  placeholder={`Search`}
                  setPage={setPage}
                  searchText={search}
                  setSearchText={setSearch}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="row"
          style={{ width: "100%", display: "flex", flexWrap: "nowrap" }}
        >
          <div className={`m-2 table-full-container"}`} style={{ flex: 1 }}>
            <div className="card">
              <div className="table-responsive">
                <table className="table">
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Organization Name</th>
                      <th scope="col">Organization Email</th>
                      <th scope="col">Batches</th>
                      <th scope="col">Tests</th>
                      <th scope="col">Country</th>
                      <th scope="col">Logo</th>
                      <th scope="col">Registered Date</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orgListDetails?.length > 0
                      ? orgListDetails?.map(
                          (orgDetails: any, orgDetailskey: any) => {
                            return (
                              <Fragment key={orgDetailskey}>
                                <tr>
                                  <th scope="row">
                                    {(page - 1) * rowsPerPage +
                                      orgDetailskey +
                                      1}
                                  </th>
                                  <td>{orgDetails?.org_name}</td>
                                  <td>{orgDetails?.org_email}</td>
                                  <td>{orgDetails?.total_batches}</td>
                                  <td>{orgDetails?.total_tests}</td>
                                  <td>
                                    <Tooltip
                                      title={orgDetails?.country}
                                      placement="bottom-start"
                                      arrow
                                    >
                                      <b>
                                        <ReactCountryFlag
                                          className="lb-row-element lb-flag"
                                          countryCode={getCountryCodeByName(
                                            orgDetails?.country
                                          )}
                                          style={{
                                            width: "clamp(20px,5vw,35px)",
                                            height: "clamp(20px,5vw,35px)",
                                          }}
                                          svg
                                        />
                                      </b>
                                    </Tooltip>
                                  </td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <div
                                      className="col-md-3 text-center"
                                      style={{
                                        width: "3em",
                                        height: "3em",
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: "3em",
                                          height: "3em",
                                        }}
                                        className="rounded-circle"
                                        src={
                                          orgDetails?.logo
                                            ? S3MediaURL + orgDetails?.logo
                                            : "/default-profile-img.png"
                                        }
                                        alt="Logo Cover"
                                      />
                                    </div>
                                  </td>
                                  <td>{formatDate(orgDetails?.updated_at)}</td>
                                  <td>
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={() =>
                                        navigate(`/organizations/${orgDetails?.id}`)
                                      }
                                    >
                                      View Details
                                    </Button>
                                  </td>
                                </tr>
                              </Fragment>
                            );
                          }
                        )
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="pagination-style">
              <Stack spacing={2}>
                <Pagination
                  count={calculateTotalPages(count, rowsPerPage)}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                  page={page}
                  onChange={(e: any, newPage) => setPage(newPage)}
                />
              </Stack>
            </div>
          </div>
        </div>
      </div>
      <CreateOrganizationDialog
        open={openCreateDialog}
        onClose={() => setOpenCreateDialog(false)}
        onCreated={() => {
          setPage(1);
          fetchOrganization(buildListParams(1));
        }}
      />
      <ToastDefault />
    </>
  );
};

export default Organizations;
